import * as React from 'react';

import {Button} from 'shells/button/button';
import {SaveButton} from 'shells/button/save-button/save-button';
import {ButtonMover} from 'shells/button-mover/button-mover';

import type {MeetingType} from 'nutshell-graphql-types';
import type {MeetingFragment as Meeting} from 'nutshell-graphql-types';

import {COHOSTED, ROUND_ROBIN} from './create-meeting-modal';

type Props = {
    onClose: () => void;
    existingMeeting: Meeting | null | undefined;
    selectedHostType: MeetingType;
    selectedCohostIds: string[];
    selectedTeamId: string | null | undefined;
    handleSave: () => void;
    isSaving: boolean;
    errorSaving: boolean;
    isSaveDisabled: boolean;
};

export function CreateMeetingModalButtons(props: Props) {
    const isCreateMeetingDisabled = () => {
        // If we are creating a new cohosted meeting, or duplicating an existing solo/cohost meeting in order to add more cohosts
        // then we return true to disable the save button if no cohosts are selected
        if (props.selectedHostType === COHOSTED || props.existingMeeting) {
            return !props.selectedCohostIds.length;
            // Else if we are creating a new round robin meeting, then we return true to disable the save button if no team is selected
        } else if (props.selectedHostType === ROUND_ROBIN) {
            return !props.selectedTeamId;
        }

        return false;
    };

    return (
        <div className='flex justify-sb align-center'>
            <ButtonMover size='big' direction='left'>
                <Button variant='text-secondary' onClick={props.onClose} size='big'>
                    Cancel
                </Button>
            </ButtonMover>
            <SaveButton
                buttonText={props.existingMeeting ? 'Make a copy & add co-hosts' : 'Create meeting'}
                savingText={'Creating meeting...'}
                size='big'
                // @ts-expect-error
                onClick={props.handleSave}
                isSaving={props.isSaving}
                errorSaving={props.errorSaving}
                disabled={props.isSaveDisabled || isCreateMeetingDisabled()}
            />
        </div>
    );
}
